


















import {
  defineComponent, computed, watch, ref,
} from '@vue/composition-api';

import { CardUploadStatusEnum, PageStatusEnum } from '@/widgets/ocr-identity/enums';
import { UploadTypeEnum } from '@/shared/tools/ocr/enum';

export default defineComponent({
  name: 'uploadBtn',
  props: {
    showForm: {
      default: false,
    },
    // 页面状态
    pageStatus: {
      default: PageStatusEnum.INIT,
    },
    // 上传方式
    uploadType: {
      default: UploadTypeEnum.SDKCamera,
    },
    // 人像面状态
    frontStatus: {
      default: CardUploadStatusEnum.PENDING,
    },
    // 国徽面状态
    backStatus: {
      default: CardUploadStatusEnum.PENDING,
    },
  },
  emits: ['upload', 'changeUploadType'],
  setup(props, context) {
    /** 是否是拍摄 */
    const isCamera = computed(() => props.uploadType === UploadTypeEnum.SDKCamera);
    const showForm = computed(() => props.showForm);
    const normalText = computed(() => (isCamera.value ? '从相册上传' : '拍摄身份证'));

    //  #region  相册文案判断
    /** 是否是单张上传 - 一张上传一张待上传 */
    const isSingleUpload = computed(() => (
      props.frontStatus === CardUploadStatusEnum.SUCCESS
        && props.backStatus === CardUploadStatusEnum.PENDING
    ) || (
      props.frontStatus === CardUploadStatusEnum.PENDING
        && props.backStatus === CardUploadStatusEnum.SUCCESS
    ));
    /** 仅人像面成功 && 国徽面删除 */
    const isFrontSuccessDel = computed(() => (props.frontStatus === CardUploadStatusEnum.SUCCESS)
      && props.backStatus === CardUploadStatusEnum.DELETE);
    /** 仅国徽面成功 && 人像面删除 */
    const isBackSuccessDel = computed(() => props.frontStatus === CardUploadStatusEnum.DELETE
      && props.backStatus === CardUploadStatusEnum.SUCCESS);
    // #endregion

    //  #region  拍摄文案判断
    /** 仅人像面成功 */
    const onlyFrontSuccess = computed(() => (props.frontStatus === CardUploadStatusEnum.SUCCESS)
      && props.backStatus !== CardUploadStatusEnum.SUCCESS);
    /** 仅国徽面成功 */
    const onlyBackSuccess = computed(() => props.frontStatus !== CardUploadStatusEnum.SUCCESS
      && props.backStatus === CardUploadStatusEnum.SUCCESS);
    // #endregion

    const getCameraText = () => {
      if (onlyFrontSuccess.value) {
        return '重新拍摄国徽面';
      }
      if (onlyBackSuccess.value) {
        return '重新拍摄人像面';
      }
      if (props.pageStatus === PageStatusEnum.INIT) {
        return '开始拍摄';
      }
      return '重新拍摄';
    };

    const getAlbumText = () => {
      if (isFrontSuccessDel.value) {
        return '重新上传国徽面';
      }
      if (isBackSuccessDel.value) {
        return '重新上传人像面';
      }
      if (isSingleUpload.value) {
        return '继续上传';
      }
      return '重新从相册上传';
    };

    /** 高亮按钮文案展示 */
    const highlightText = computed(() => {
      if (isCamera.value) {
        return getCameraText();
      } // 相册上传
      return getAlbumText();
    });

    const onUpload = () => {
      context.emit('upload');
    };

    const onChangeUpload = () => {
      context.emit('changeUploadType');
    };

    return {
      isCamera,
      showForm,
      highlightText,
      normalText,
      onUpload,
      onChangeUpload,
    };
  },
});
